import styled from "styled-components";

type PropsType = {
    label: string;
    options: {value: number, label: string}[];
    value: number;
    onChange: (newValue: number) => void;
}

export default ({ label, options, value, onChange }: PropsType): JSX.Element => (
    <SelectorLabel>
        {label}
        <StyledSelect value={value} onChange={(event) => onChange(Number(event.target.value))}>
            {options.map((item) =>
                <option key={item.value} value={item.value}>{item.label}</option>
            )}
        </StyledSelect>
    </SelectorLabel>
);

const SelectorLabel = styled.label`
    color: hsl(0, 0, 30%);
`;

const HEIGHT = 20;
const COLOR_IDLE = "#4c4c4c";
const COLOR_HOVER = "black";

const StyledSelect = styled.select`
    position: relative;
    height: ${HEIGHT}px;
    line-height: ${HEIGHT - 2}px;
    vertical-align: bottom;
    appearance: none;
    margin-left: 8px;
    padding: 0 14px 0 4px;
    font-size: 14px;
    color: ${COLOR_IDLE};
    border: 1px solid ${COLOR_IDLE};
    border-radius: ${HEIGHT / 3}px;
    background: white url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='4' viewBox='0 0 10 4'><polygon fill='%23404040' points='0,0 6,0 3,4'/></svg>");
    background-position: right center;
    background-repeat: no-repeat;
    cursor: pointer;
    
    option {
        font-size: 14px;
        font-weight: normal;
    }
    
    @media (pointer: fine) {
        &:hover {
            color: ${COLOR_HOVER};
            border-color: ${COLOR_HOVER};
        }
    }
`;